"use strict";
import s from "./index.es144.js";
import b from "./index.es268.js";
const d = Symbol("internals");
function h(i) {
  return i && String(i).trim().toLowerCase();
}
function p(i) {
  return i === !1 || i == null ? i : s.isArray(i) ? i.map(p) : String(i);
}
function S(i) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let e;
  for (; e = r.exec(i); )
    t[e[1]] = e[2];
  return t;
}
const E = (i) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(i.trim());
function y(i, t, r, e, n) {
  if (s.isFunction(e))
    return e.call(this, t, r);
  if (n && (t = r), !!s.isString(t)) {
    if (s.isString(e))
      return t.indexOf(e) !== -1;
    if (s.isRegExp(e))
      return e.test(t);
  }
}
function O(i) {
  return i.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, e) => r.toUpperCase() + e);
}
function A(i, t) {
  const r = s.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((e) => {
    Object.defineProperty(i, e + r, {
      value: function(n, o, c) {
        return this[e].call(this, t, n, o, c);
      },
      configurable: !0
    });
  });
}
class m {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, e) {
    const n = this;
    function o(a, f, l) {
      const u = h(f);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const g = s.findKey(n, u);
      (!g || n[g] === void 0 || l === !0 || l === void 0 && n[g] !== !1) && (n[g || f] = p(a));
    }
    const c = (a, f) => s.forEach(a, (l, u) => o(l, u, f));
    if (s.isPlainObject(t) || t instanceof this.constructor)
      c(t, r);
    else if (s.isString(t) && (t = t.trim()) && !E(t))
      c(b(t), r);
    else if (s.isObject(t) && s.isIterable(t)) {
      let a = {}, f, l;
      for (const u of t) {
        if (!s.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        a[l = u[0]] = (f = a[l]) ? s.isArray(f) ? [...f, u[1]] : [f, u[1]] : u[1];
      }
      c(a, r);
    } else
      t != null && o(r, t, e);
    return this;
  }
  get(t, r) {
    if (t = h(t), t) {
      const e = s.findKey(this, t);
      if (e) {
        const n = this[e];
        if (!r)
          return n;
        if (r === !0)
          return S(n);
        if (s.isFunction(r))
          return r.call(this, n, e);
        if (s.isRegExp(r))
          return r.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = h(t), t) {
      const e = s.findKey(this, t);
      return !!(e && this[e] !== void 0 && (!r || y(this, this[e], e, r)));
    }
    return !1;
  }
  delete(t, r) {
    const e = this;
    let n = !1;
    function o(c) {
      if (c = h(c), c) {
        const a = s.findKey(e, c);
        a && (!r || y(e, e[a], a, r)) && (delete e[a], n = !0);
      }
    }
    return s.isArray(t) ? t.forEach(o) : o(t), n;
  }
  clear(t) {
    const r = Object.keys(this);
    let e = r.length, n = !1;
    for (; e--; ) {
      const o = r[e];
      (!t || y(this, this[o], o, t, !0)) && (delete this[o], n = !0);
    }
    return n;
  }
  normalize(t) {
    const r = this, e = {};
    return s.forEach(this, (n, o) => {
      const c = s.findKey(e, o);
      if (c) {
        r[c] = p(n), delete r[o];
        return;
      }
      const a = t ? O(o) : String(o).trim();
      a !== o && delete r[o], r[a] = p(n), e[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return s.forEach(this, (e, n) => {
      e != null && e !== !1 && (r[n] = t && s.isArray(e) ? e.join(", ") : e);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const e = new this(t);
    return r.forEach((n) => e.set(n)), e;
  }
  static accessor(t) {
    const r = (this[d] = this[d] = {
      accessors: {}
    }).accessors, e = this.prototype;
    function n(o) {
      const c = h(o);
      r[c] || (A(e, o), r[c] = !0);
    }
    return s.isArray(t) ? t.forEach(n) : n(t), this;
  }
}
m.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
s.reduceDescriptors(m.prototype, ({ value: i }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => i,
    set(e) {
      this[r] = e;
    }
  };
});
s.freezeMethods(m);
export {
  m as default
};
//# sourceMappingURL=index.es158.js.map
